import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDateTimeFormat } from "helpers/utils";


export function Footer({ data }) {

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end w-100'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex w-100">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start w-40'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end w-60'><Label data='HeaderMatch' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
  
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            <div className='score-name'>
                {competitor?.cp_code === 'NOCOMP' || competitor?.cp_code === 'BYE'
                    ? competitorPlace
                    : !competitor.cp_prev_wlt
                        ? competitor?.cp_prev_pos
                        : <></>
                }
            </div>
        </div>
    )
}

function PlayerPosition({ pos }) {
    switch (pos) {
        case '1':
            return (
                <>
                    {pos + 'st'}
                </>
            )
        case '2':
            return (
                <>
                    {pos + 'nd'}
                </>
            )
        case '3':
            return (
                <>
                    {pos + 'rd'}
                </>
            )
        case '4': case '5': case '6': case '7': case '8':
            return (
                <>
                    {pos + 'th'}
                </>
            )
    }
}
